module.exports = __webpack_public_path__ + "img/p6.44c51469.png";